export default __webpack_public_path__ + "static/media/landscape07.2d086e9b.png";